import React from "react";
import classes from "./SelectThumbnailPopUp.module.scss";
import thumbnailImg from "../../../assets/images/Common/Group_1102.svg";
import { useDispatch } from "react-redux";
import { setErrorHandler } from "../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../utils/errorTypes";
import Modal from "../Modal/Modal";
import Button from "../Button/Button";

const SelectThumbnailPopUp = ({
  isOpenModal,
  setIsOpenModal,
  fileRef,
  name = "thumbnailImageFile",
  setValue,
  accept = ".png, .jpg, .gif, .bmp",
  acceptedExtensionArray = [
    "image/png",
    "image/jpeg",
    "image/gif",
    "image/bmp",
  ],
  warnMsg = "Please select a valid format from [.png, .jpg, .gif, .bmp]",
  setThumbnailFileName,
  heading = "Upload (or) Select Thumbnail",
  width = "90",
  okBtnClick,
  setErrorMsg,
  fileWarnMsg = "Selected ['png', 'jpg', 'gif', 'bmp', 'jpeg'] Size must not exceed 10MB",
}) => {
  const dispatch = useDispatch();

  const fileChange = (event) => {
    event.preventDefault();
    let files = event.target.files[0];
    const fileSize = files.size / 1024 / 1024;
    setValue(name, event.target.files);
    setThumbnailFileName(files?.name);
    if (setErrorMsg) setErrorMsg("");
    if (!acceptedExtensionArray.includes(files.type)) {
      setValue(name, "");
      setThumbnailFileName("");
      dispatch(setErrorHandler(errorTypes.WARN, warnMsg));
    } else if (acceptedExtensionArray.includes(files.type) && fileSize > 10) {
      setValue(name, "");
      setThumbnailFileName("");
      dispatch(setErrorHandler(errorTypes.WARN, fileWarnMsg));
    } else {
      setIsOpenModal(false);
    }
  };

  return (
    <Modal
      isOpen={isOpenModal}
      heading={heading}
      toggle={() => setIsOpenModal(false)}
      width={width}
    >
      <div className={classes.select_thumbnail_pop_up}>
        <p className={classes.para_1}>
          We recommend uploading a high-quality image to ensure an optimal
          display on all devices and screen sizes. Our accepted image formats
          for thumbnail images are <b>.png,.jpg,.gif,.bmp</b>
        </p>
        <hr color="#eee" />
        <p className={classes.para_2}>
          <b>
            We recommend below mentioned image size guidelines to ensure these
            images look great in our Web client Portal and Mobile Client Apps
          </b>
        </p>
        <center>
          <img
            src={thumbnailImg}
            alt="centered img"
            className={classes.thumbnail_img}
          />
        </center>
        <hr color="#eee" />
        <div className={classes.ok_btn}>
          <input
            type="file"
            hidden
            ref={fileRef}
            name={name}
            onChange={fileChange}
            accept={accept}
          />
          <Button
            type="button"
            label="OK"
            dark
            width="15"
            height="4"
            onClick={okBtnClick}
          />
        </div>
      </div>
    </Modal>
  );
};

export default SelectThumbnailPopUp;
